export default __webpack_public_path__ + "static/vace1-e654c2719c18e32182dd128297ec4498.jpeg";